<script lang="ts" setup>
/* eslint-disable quote-props */
const YELP_SMALL_RATING_IMAGES: { [key: string]: string } = {
  '0.0': 'https://assets2.giftly.com/yelp-stars/regular_0.png',
  0.5: 'https://assets2.giftly.com/yelp-stars/regular_0.png',
  '1.0': 'https://assets2.giftly.com/yelp-stars/regular_1.png',
  1.5: 'https://assets2.giftly.com/yelp-stars/regular_1_half.png',
  '2.0': 'https://assets2.giftly.com/yelp-stars/regular_2.png',
  2.5: 'https://assets2.giftly.com/yelp-stars/regular_2_half.png',
  '3.0': 'https://assets2.giftly.com/yelp-stars/regular_3.png',
  3.5: 'https://assets2.giftly.com/yelp-stars/regular_3_half.png',
  '4.0': 'https://assets2.giftly.com/yelp-stars/regular_4.png',
  4.5: 'https://assets2.giftly.com/yelp-stars/regular_4_half.png',
  '5.0': 'https://assets2.giftly.com/yelp-stars/regular_5.png',
}
/* eslint-enable quote-props */

const { rating } = defineProps<{
  rating: string | number
}>()

const roundReview = (num: number) => Math.round(num * 2) / 2

const ratingImage = computed(() => {
  const roundedRating = roundReview(Number(rating))
  return YELP_SMALL_RATING_IMAGES[roundedRating.toFixed(1)]
})
</script>

<template>
  <img :src="ratingImage" :alt="`Yelp Rating: ${rating}`" width="88" height="16" class="w-66px h-3">
</template>
